export default {
  strict: true,
  namespaced: true,
  state: {
    show: false,
    notes: ''
  },
  mutations: {
    show (state, value) { state.show = value },
    setNotes (state, value) { state.notes = value }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/refund-credit-modal.js